const state = {
  asyncData: {},
  query: "",
  count: 0,
  page: 1
};
const mutations = {
  SET_ASYNC_DATA(state, payload = {}) {
    state.asyncData = payload;
  },
  SET_QUERY(state, payload = "") {
    state.query = payload;
  },
  SET_PAGE(state, payload = 1) {
    state.page = payload;
  },
  SET_COUNT(state, payload = 0) {
    state.count = payload;
  }
};
const actions = {};
const getters = {
  asyncData: state => state.list.asyncData
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// src/store/modules/list.js